export const GRAPHQL_URI = `${window.location.origin}/graphql`;
